/**
 * Common Media Streaming Format
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */
export var CmStreamingFormat;
(function (CmStreamingFormat) {
    /**
     * MPEG DASH
     */
    CmStreamingFormat["DASH"] = "d";
    /**
     * HTTP Live Streaming (HLS)
     */
    CmStreamingFormat["HLS"] = "h";
    /**
     * Smooth Streaming
     */
    CmStreamingFormat["SMOOTH"] = "s";
    /**
     * Other
     */
    CmStreamingFormat["OTHER"] = "o";
})(CmStreamingFormat || (CmStreamingFormat = {}));
//# sourceMappingURL=CmStreamingFormat.js.map